import React from "react";

function CompleteLecture({ completeLectureCount, completeRate }) {
    return (
        <>
            <div className="lectureTxt1">{completeLectureCount}강</div>
            <div className="lectureBar">
                <span className="porgress_bar" style={{ width: completeRate + "%" }}></span>
            </div>
        </>
    );
}

export default CompleteLecture;
